import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {appRatingLoadData} from 'store/app-rating/app-rating-actions';

const useAppstoreRating = ({
    loadingText = 'Fetching App Store rating...',
    ratingText = 'iOS App Store',
} = {}) => {
    const appRating = useSelector(state => state.appRating.data);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!appRating) {
            dispatch(appRatingLoadData());
        }
    }, [dispatch, appRating]);

    const {rating, ratingCount} = appRating || {
        rating: null,
        ratingCount: null,
    };
    const text = rating ? `${rating}/5 ${ratingText}` : loadingText;

    return {
        rating,
        text,
        ratingCount,
    };
};

export default useAppstoreRating;
